import { useEffect } from "react";

/**
 * Closes a hand-rolled `role="dialog"` overlay on Escape, matching the
 * behavior of the shared `ModalSheet` component. Pair with an `onClick`
 * handler on the backdrop element (call `onClose` only when the event
 * target is the backdrop itself, not a child, to avoid closing on clicks
 * inside the dialog panel).
 */
export function useDialogDismiss(isOpen: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);
}
